module.exports = __webpack_public_path__ + "img/how7.b0c61bfc.png";